import EntityCrudPage from '../../shared/EntityCrudPage';
import { documentConfig } from '../../config/entityConfigs';

const DocumentsPage = () => <EntityCrudPage config={documentConfig} />;

export default DocumentsPage;
